<template>
  <b-modal
    ref="modal_calificaciones"
    size="lg"
    :title="'Comentarios recientes para ' + empresa.nombre"
    scrollable
    hide-footer
  >
    <b-overlay :show="consulta_en_progreso">
      <div ref="div_modal_calificaciones" class="row d-flex align-items-center">
        <div class="col-md-3 mb-3 text-center">
          <img
            v-if="empresa.logo"
            id="logo_empresa_calif"
            alt="Mudanzas DF"
            :src="base_url + empresa.logo"
            style="height: 70px"
          />
        </div>
        <div
          v-if="
            estadisticas_calificaciones &&
              estadisticas_calificaciones.calificacion_promedio > 0
          "
          class="col-md-9 mb-3"
        >
          <div class="row d-flex align-items-center">
            <div class="col-md-6 mb-md-0 mb-3 text-center">
              <span
                v-if="
                  solo_mostrar_n_calificaciones > 0 &&
                    (typeof estadisticas_calificaciones.total_calificaciones ==
                      'undefined' ||
                      estadisticas_calificaciones.total_calificaciones < 5)
                "
                class="text-semibold"
              >
                Esta empresa aún no tiene suficientes ventas para calcular su
                reputación
              </span>
              <div v-else>
                <h1 class="display-4">
                  {{ estadisticas_calificaciones.calificacion_promedio }}/5
                </h1>
                <b-form-rating
                  v-model="empresa.promedio_estrellas_real"
                  variant="warning"
                  size="lg"
                  no-border
                  readonly
                >
                </b-form-rating>
                <span
                  v-if="solo_mostrar_n_calificaciones == 0"
                  class="text-muted"
                >
                  Promedio entre
                  {{
                    estadisticas_calificaciones.total_calificaciones
                  }}
                  opiniones
                </span>
                <span v-else class="text-muted">
                  Promedio entre
                  {{
                    estadisticas_calificaciones.total_calificaciones
                  }}
                  opiniones recibidas en los últimos
                  {{
                    estadisticas_calificaciones.meses_calificacion_reciente
                  }}
                  meses
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div
                v-if="
                  estadisticas_calificaciones.cantidad_calificaciones_5_estrella >
                    0
                "
                class="row d-flex align-items-center"
              >
                <div class="col-4 text-right">
                  <small class="text-muted">5 estrellas</small>
                </div>
                <div class="col-6">
                  <b-progress
                    height="4px"
                    :value="
                      (estadisticas_calificaciones.cantidad_calificaciones_5_estrella *
                        100) /
                        estadisticas_calificaciones.total_calificaciones
                    "
                  ></b-progress>
                </div>
                <div class="col-2 text-left">
                  <small class="text-muted">{{
                    estadisticas_calificaciones.cantidad_calificaciones_5_estrella
                  }}</small>
                </div>
              </div>
              <div
                v-if="
                  estadisticas_calificaciones.cantidad_calificaciones_4_estrella >
                    0
                "
                class="row d-flex align-items-center"
              >
                <div class="col-4 text-right">
                  <small class="text-muted">4 estrellas</small>
                </div>
                <div class="col-6">
                  <b-progress
                    height="4px"
                    :value="
                      (estadisticas_calificaciones.cantidad_calificaciones_4_estrella *
                        100) /
                        estadisticas_calificaciones.total_calificaciones
                    "
                  ></b-progress>
                </div>
                <div class="col-2 text-left">
                  <small class="text-muted">{{
                    estadisticas_calificaciones.cantidad_calificaciones_4_estrella
                  }}</small>
                </div>
              </div>
              <div
                v-if="
                  estadisticas_calificaciones.cantidad_calificaciones_3_estrella >
                    0
                "
                class="row d-flex align-items-center"
              >
                <div class="col-4 text-right">
                  <small class="text-muted">3 estrellas</small>
                </div>
                <div class="col-6">
                  <b-progress
                    height="4px"
                    :value="
                      (estadisticas_calificaciones.cantidad_calificaciones_3_estrella *
                        100) /
                        estadisticas_calificaciones.total_calificaciones
                    "
                  ></b-progress>
                </div>
                <div class="col-2 text-left">
                  <small class="text-muted">{{
                    estadisticas_calificaciones.cantidad_calificaciones_3_estrella
                  }}</small>
                </div>
              </div>
              <div
                v-if="
                  estadisticas_calificaciones.cantidad_calificaciones_2_estrella >
                    0
                "
                class="row d-flex align-items-center"
              >
                <div class="col-4 text-right">
                  <small class="text-muted">2 estrellas</small>
                </div>
                <div class="col-6">
                  <b-progress
                    height="4px"
                    :value="
                      (estadisticas_calificaciones.cantidad_calificaciones_2_estrella *
                        100) /
                        estadisticas_calificaciones.total_calificaciones
                    "
                  ></b-progress>
                </div>
                <div class="col-2 text-left">
                  <small class="text-muted">{{
                    estadisticas_calificaciones.cantidad_calificaciones_2_estrella
                  }}</small>
                </div>
              </div>
              <div
                v-if="
                  estadisticas_calificaciones.cantidad_calificaciones_1_estrella >
                    0
                "
                class="row d-flex align-items-center"
              >
                <div class="col-4 text-right">
                  <small class="text-muted">1 estrella</small>
                </div>
                <div class="col-6">
                  <b-progress
                    height="4px"
                    :value="
                      (estadisticas_calificaciones.cantidad_calificaciones_1_estrella *
                        100) /
                        estadisticas_calificaciones.total_calificaciones
                    "
                  ></b-progress>
                </div>
                <div class="col-2 text-left">
                  <small class="text-muted">{{
                    estadisticas_calificaciones.cantidad_calificaciones_1_estrella
                  }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-md-9 mb-3">
          <span class="text-semibold">
            Esta empresa aún no tiene suficientes ventas para calcular su
            reputación
          </span>
        </div>
      </div>
      <div class="d-none d-md-block">
        <div class="row bg-light mb-4 py-2 text-muted">
          <div class="col-md-3">
            <b>Cliente</b>
          </div>
          <div class="col-md-3">
            <b>Calificación</b>
          </div>
          <div class="col-md-6">
            <b>Valoración</b>
          </div>
        </div>
      </div>
      <div>
        <div v-for="c in calificaciones" :key="c.id_mm">
          <div class="row">
            <div class="col-12 col-md-3">
              <ul class="list-unstyled mb-0">
                <li v-if="c.solicitud && c.solicitud.nombre_cliente">
                  <b>{{ abreviarApellidos(c.solicitud.nombre_cliente) }}</b>
                </li>
                <li>
                  <small class="text-muted">
                    {{ c.cotizacion_contratada.folio_carta_porte }}-{{
                      c.cotizacion_contratada.id_carta_porte
                    }}
                  </small>
                </li>
                <li>
                  <small
                    v-b-tooltip.hover
                    :title="moment(c.fecha_registro).format('DD/MM/YYYY')"
                  >
                    {{ moment(c.fecha_registro).fromNow() }}
                  </small>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-3">
              <b-form-rating
                v-model="c.calif_empresa"
                variant="warning"
                show-value
                show-value-max
                size="sm"
                no-border
                readonly
              ></b-form-rating>
            </div>
            <div class="col-12 col-md-6">
              <span v-if="c.comentario != ''" class="text-muted">
                {{ c.comentario }}
              </span>
              <em v-else class="text-muted">No dejó comentario</em>

              <div v-for="(chat, i) in c.chat" :key="i" class="col-12 mt-3">
                <div
                  :class="[
                    chat.tipo_usuario == 'proveedor'
                      ? 'text-right bd-callout-right bd-callout-success'
                      : 'bd-callout bd-callout-info',
                  ]"
                >
                  <ul class="list-unstyled mb-0">
                    <li>{{ chat.comentario }}</li>
                    <li>
                      <small class="text-muted">
                        {{ empresa.nombre }}
                      </small>
                    </li>
                    <li>
                      <small class="text-muted">{{
                        moment(chat.created_at).fromNow()
                      }}</small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { abreviarApellidos } from 'views/components/library/name_helper.js';

require('moment/locale/es');

Vue.prototype.moment = moment;

export default {
  props: {
    id_mm: {
      type: [Number, String],
      default: ''
    },
    clave: {
      type: [Number, String],
      default: ''
    },
    id_empresa: {
      type: [String, Number],
      default: ''
    },
    solo_mostrar_n_calificaciones: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      empresa: {
        nombre: '...'
      },
      calificaciones: [],
      estadisticas_calificaciones: {},
      consulta_en_progreso: false,
      currentPage: 1,
      rows: 0,
      base_url,
      id_visita: null
    };
  },
  methods: {
    abreviarApellidos,
    show_modal() {
      this.$refs.modal_calificaciones.show();
      this.get_calificaciones();
    },
    get_calificaciones() {
      this.consulta_en_progreso = true;
      let querys = '';
      let input_variables = null;
      const calificaciones_a_mostrar = this.solo_mostrar_n_calificaciones == 0 ? 10 : this.solo_mostrar_n_calificaciones;

      if (typeof this.empresa.logo === 'undefined') {
        let columnas_a_consultar = `
        total_calificaciones
        calificacion_promedio
        cantidad_calificaciones_1_estrella
        cantidad_calificaciones_2_estrella
        cantidad_calificaciones_3_estrella
        cantidad_calificaciones_4_estrella
        cantidad_calificaciones_5_estrella
        `;

        if (this.solo_mostrar_n_calificaciones > 0) {
          columnas_a_consultar = `
          meses_calificacion_reciente
          total_calificaciones_recientes
          calificacion_promedio_reciente
          cantidad_calificaciones_1_estrella_reciente
          cantidad_calificaciones_2_estrella_reciente
          cantidad_calificaciones_3_estrella_reciente
          cantidad_calificaciones_4_estrella_reciente
          cantidad_calificaciones_5_estrella_reciente
          `;
        }

        querys += `
        calificacion_estadisticas(empresas_id: ${this.id_empresa}) {
          ${columnas_a_consultar}
        }
        empresa: get_empresa(id: ${this.id_empresa}) {
            nombre
            logo
            promedio_estrellas_real
        }`;
      }
      querys += `calificaciones(first:${calificaciones_a_mostrar}, page: ${this.currentPage}, where: {
        AND: [
            { column: CLAVE, operator: EQ, value: ${this.clave} }
            { column: ESTRELLAS, operator: GT, value: 0 }
        ]
        }
        orderBy: [{ field: FECHA_CALIFICACION, order: DESC }]
        ) {
            data {
                id_mm
                calif_empresa
                comentario
                fecha_registro
                solicitud {
                    nombre_cliente
                }
                cotizacion_contratada {
                    folio_carta_porte
                    id_carta_porte
                }
                chat {
                    tipo_usuario
                    comentario
                    created_at
                }
            }
            paginatorInfo {
                total
            }
        }`;

      if (this.id_visita == null && this.id_mm > 0) {
        querys += `upsert_calif_perfil_visto(input: $input_upsert_visita) {
            id
        }`;

        input_variables = {
          input_upsert_visita: {
            id_mm: parseInt(this.id_mm, 10),
            empresa: this.clave,
            accion: 'calificacion'
          }
        };
      }

      this.$http.post(`${api_url}graphql`, {
        query: `${this.id_visita == null && this.id_mm > 0 ? 'query ($input_upsert_visita: upsert_visita!)' : ''}{${querys}}`,
        variables: input_variables
      }, { timeout: 30000 }).then((r) => {
        this.calificaciones = r.body.data.calificaciones.data;
        this.rows = r.body.data.calificaciones.paginatorInfo.total;

        if (typeof this.empresa.logo === 'undefined') {
          this.empresa = r.body.data.empresa;
          if (this.solo_mostrar_n_calificaciones > 0) {
            this.asignar_calificaciones_recientes(r.body.data.calificacion_estadisticas);
          } else {
            this.estadisticas_calificaciones = r.body.data.calificacion_estadisticas;
          }
        }
        this.consulta_en_progreso = false;

        if (this.id_visita == null && this.id_mm > 0) {
          this.id_visita = r.body.data.upsert_calif_perfil_visto.id;
        }

        this.$nextTick(() => {
          const div_to_top = this.$refs.div_modal_calificaciones;
          div_to_top.scrollIntoView({ behavior: 'smooth' });
        });
      }, () => {
        this.consulta_en_progreso = false;
        alert('No podemos comunicarnos con el servidor o esta tardando mucho en responder. Inténtelo más tarde');
      });
    },
    asignar_calificaciones_recientes(estadisticas) {
      this.estadisticas_calificaciones = {
        meses_calificacion_reciente: estadisticas.meses_calificacion_reciente,
        total_calificaciones: estadisticas.total_calificaciones_recientes,
        calificacion_promedio: estadisticas.calificacion_promedio_reciente,
        cantidad_calificaciones_1_estrella: estadisticas.cantidad_calificaciones_1_estrella_reciente,
        cantidad_calificaciones_2_estrella: estadisticas.cantidad_calificaciones_2_estrella_reciente,
        cantidad_calificaciones_3_estrella: estadisticas.cantidad_calificaciones_3_estrella_reciente,
        cantidad_calificaciones_4_estrella: estadisticas.cantidad_calificaciones_4_estrella_reciente,
        cantidad_calificaciones_5_estrella: estadisticas.cantidad_calificaciones_5_estrella_reciente
      };
    }
  }
};
</script>

<style lang="scss">
.bd-callout-info {
  border-left-color: #17a2b8 !important;
}

.bd-callout {
  padding: 1.25rem;
  border: 1px solid #eee;
  border-left-width: 0.25rem;
  border-radius: 0.25rem;
}

.bd-callout-success {
  border-right-color: #28a745 !important;
}

.bd-callout-right {
  padding: 1.25rem;
  border: 1px solid #eee;
  border-right-width: 0.25rem;
  border-radius: 0.25rem;
}
</style>
